import React, {PropTypes} from 'react';
import {connect} from 'react-redux';


// import * as commonActionCreators from '../../../actions/common';
let allActionCreators = Object.assign({});

class EducationLabGrown extends React.Component {

	static propTypes = {
    location: PropTypes.object
  };

  static contextTypes = {
    store: PropTypes.any,
    router: React.PropTypes.object.isRequired
  };

	constructor(props) {
		super(props);
		this.state = {}
	}

	componentDidMount() {
    document.title = 'Diamonds Direct - Lab Grown Diamonds';
    document.getElementsByTagName("META")[7].content="Shop our extensive selection of diamond engagement rings, wedding bands, and other jewelry online. See the Diamonds Direct Difference today!";
  }

  newTabNav(page) {
  	let win = window.open(page, '_blank');
    win.focus();
  }

  externalNav(page) {
    window.location.href = '/' + page;
  }

  internalNav(page) {
  	this.context.router.push('/' + page);
  }

  openIntercom() {
    acquireIO.max();
  }

  openNew(page) {
    let win = window.open(page, '_blank');
    win.focus();
  }

	render() {
		return <div className={'EducationLabGrown EducationPage'}>
      <div className='eduHeader'>Lab Grown Diamonds</div>
      <div className='labHoliday'>
        <div className='holidayWrapper'>
          <img className='desktopOnly' src='https://ddw2.diamondsdirect.com/img/education/lab/holiday.jpg' />
          <img className='mobileOnly' src='https://ddw2.diamondsdirect.com/img/education/lab/holiday_m.jpg' />
          <div className='holidayAction' onClick={() => this.internalNav('contact-us')}><div>Connect With An Expert</div></div>
        </div>
      </div>
      <div className='eduBody'>
        <div className='labHeader'>
          <div className={'labHeaderImage desktopOnly'}>
            <img src='https://ddw2.diamondsdirect.com/img/education/lab/header_text.jpg' />
          </div>
          <div className={'labHeaderImage mobileOnly'}>
            <img src='https://ddw2.diamondsdirect.com/img/education/lab/header_m.jpg' />
          </div>
        </div>
        <div className='labCopy'>
          <div className={'labCopyBlock mobile'}>
            <div className='copyTitle'>What are Lab Grown Diamonds?</div>
            <div className='copyP'>Lab grown diamonds are created in a controlled environment mimicking the way natural diamonds are formed. The end result is a man-made diamond with the same chemical and physical properties as natural diamonds.</div>
          </div>
        </div>
        <div className='labCompare'>
          <div className='blockWrapper'>
            <div className='compareBlock'>
              <div className='compareIcon'>
                <div className='compareIconWrapper'>
                  <img src='https://ddw2.diamondsdirect.com/img/education/lab/natural.svg' />
                </div>
              </div>
              <div className='compareTitle'>Natural Diamonds</div>
              <div className='compareProConWrapper'>
                <div className='compareLabel'>PRO:</div>
                <div className='compareValue'>Rarity</div>
              </div>
              <div className='compareProConWrapper'>
                <div className='compareLabel'>CON:</div>
                <div className='compareValue'>Price is higher per carat</div>
              </div>
            </div>
            <div className='compareBlock'>
              <div className='compareIcon'>
                <div className='compareIconWrapper'>
                  <img src='https://ddw2.diamondsdirect.com/img/education/lab/lab.svg' />
                </div>
              </div>
              <div className='compareTitle'>Lab Grown Diamonds</div>
              <div className='compareProConWrapper'>
                <div className='compareLabel'>PRO:</div>
                <div className='compareValue'>Affordability</div>
              </div>
              <div className='compareProConWrapper'>
                <div className='compareLabel'>CON:</div>
                <div className='compareValue'>Limited resale and upgrade potential</div>
              </div>
            </div>
          </div>
        </div>
        <div className='labCopy'>
          <div className={'labCopyBlock'} style={{ margin: '0' }}>
            <div className='copyTitle'>What differentiates a natural diamond from a lab-grown one?</div>
            <div className='copyP'>Although natural and lab grown diamonds have many similarities, there are two main differences that you should be aware of: Natural diamonds were formed millions, or even billions, of years ago below the Earth’s surface. The oldest lab grown diamonds were made decades ago and formed under conditions designed by humans in large factories or lab facilities. Natural diamonds have greater inherent value due to limited supply. The rarity of natural diamonds ensures they retain their value over time so that natural diamonds can be resold, traded in, and upgraded in the future. Lab grown diamond prices are typically much lower because they are mass-manufactured and readily available in unlimited quantities. Manufactured diamond pricing has historically decreased annually by as much as 30% in a year, which impacts its value. While the savings are perhaps enticing, it’s essential to understand that lab grown diamonds do not retain their value after purchase.</div>
          </div>
        </div>
        <div className='labCompare'>
          <div className='compareCopyWrapper'>
            <div className='ccTitle'>Selection, Guidance & Value Redefined.</div>
            <div className='ccP'>As always, Diamonds Direct is here to provide expert guidance and diamond education to empower you, our customers, to make buying decisions that meet your specific needs and wishes.</div>
          </div>
        </div>
        <div className='labGrid'>
          <div className='labRow copyRight'>
            <div className='imageBlock'></div>
            <div className='copyBlock'>
              <div className='copyBlockLiner'>
                <div className='rcTitle'>Explore our Lab Grown Diamond Collection in Store</div>
                <div className='rcP' style={{ display: 'inline-block', textDecoration: 'underline' }}>Lab Grown</div>
                <div className='rcP'>Loose & Mounted Diamond Engagement</div>
                <div className='rcP'>Diamond Studs</div>
                <div className='rcP'>Diamond Pendants</div>
                <div className='rcP'>Diamond Tennis Bracelets</div>
                <div className='lcActions'>
                  <div className='lcAction' onClick={() => this.internalNav('locations')}>Find a Location</div>
                </div>
              </div>
            </div>
          </div>
          <div className='labRow copyLeft'>
            <div className='imageBlock'></div>
            <div className='copyBlock'>
              <div className='copyBlockLiner'>
                <div className='lcP'>Our experts have an expansive selection of lab grown and natural diamonds at their fingertips. We are ready to guide you through our inventory and educate you on the pros and cons of both diamond types in an effort to help you make a buying decision that suits your needs.</div>
                <div className='lcTitle'>Connect with an Expert</div>
                <div className='lcActions'>
                  <div className='lcAction' onClick={() => this.internalNav('contact-us')}>Connect With An Expert</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
		</div>;
	}
}
export default EducationLabGrown;

function mapStateToProps(state) {
  return {

  };
}

export const EducationLabGrownContainer = connect(
  mapStateToProps,
  allActionCreators
)(EducationLabGrown);


// WEBPACK FOOTER //
// ./src/components/views/education/EducationLabGrown.jsx